var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTikTokLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 6.56C12.6235 6.56277 11.2809 6.13285 10.1621 5.331V10.919C10.1617 11.9541 9.8453 12.9643 9.25518 13.8147C8.66506 14.6651 7.82935 15.3149 6.85985 15.6774C5.89034 16.0399 4.83326 16.0977 3.83 15.8431C2.82674 15.5885 1.92514 15.0337 1.2458 14.2527C0.566464 13.4718 0.141778 12.5021 0.0285501 11.4732C-0.0846775 10.4444 0.118952 9.40547 0.612202 8.4955C1.10545 7.58552 1.8648 6.84785 2.78868 6.38117C3.71256 5.91448 4.75691 5.74102 5.78205 5.884V8.694C5.3137 8.54648 4.81071 8.55069 4.34489 8.70605C3.87908 8.8614 3.47425 9.15995 3.18821 9.55907C2.90216 9.95819 2.74953 10.4375 2.75208 10.9285C2.75464 11.4195 2.91227 11.8972 3.20246 12.2933C3.49265 12.6894 3.90056 12.9838 4.36797 13.1342C4.83538 13.2847 5.33839 13.2837 5.80518 13.1313C6.27197 12.9789 6.67868 12.6829 6.96725 12.2856C7.25582 11.8883 7.4115 11.41 7.41205 10.919V0H10.1621C10.161 0.233 10.1811 0.465 10.2221 0.694C10.3176 1.20425 10.5163 1.68965 10.8058 2.12053C11.0954 2.55141 11.4697 2.91872 11.9061 3.2C12.5271 3.61 13.2561 3.829 14.0001 3.828V6.56Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTokLogo);
export default __webpack_public_path__ + "static/media/TikTok Logo.7b4fa1c03ad9a2710700fbc5621e8cc7.svg";
export { ForwardRef as ReactComponent };